angular.module('lsnBase.deprecated.models')
  .factory('CompositeSubjectSelectConfigModel', ['LsnCompositeSubjectSelectConfigModelV1',
    function(LsnCompositeSubjectSelectConfigModelV1) {
      return LsnCompositeSubjectSelectConfigModelV1;
    }
  ]);